// extracted by mini-css-extract-plugin
export default {"container":"TabBar_container__ta0EU","tabs":"TabBar_tabs__Tle78","tab":"TabBar_tab__u-oN6","active":"TabBar_active__fb6oA","searchCount":"TabBar_searchCount__l17Ye"};